import * as React from "react";

const LastPage: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="10" viewBox="0 0 9 10" fill="none">
            <path
                d="M1.04054 0.5L5.4112 5L1.04054 9.5L0.5 8.93551L4.32239 5L0.5 1.06449L1.04054 0.5ZM4.12934 0.5L8.5 5L4.12934 9.5L3.5888 8.93551L7.4112 5L3.5888 1.06449L4.12934 0.5Z"
                fill="black"
            />
        </svg>
    );
};

export default React.memo(LastPage);
